import React, { useState, useEffect } from 'react';
import { LinkedinLogo, WarningCircle } from "@phosphor-icons/react";
import "./LoginPage.scss"
import { useNavigate } from 'react-router-dom';
import Loading from '../components/loading/Loading';

export const LoginPage = () => {
  const [isSafari, setIsSafari] = useState(false);
  const [isFirefox, setIsFirefox] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
      setIsSafari(true);
    }
    if (userAgent.includes('firefox')) {
      setIsFirefox(true);
    }
  }, []);

  const navigate = useNavigate(); // Initialize the navigate function

  return (
    <div data-component="LoginPage">

      <main>

        <div className="login-header">

          <h1>Nail your next interview</h1>
          <p>Practice screening interviews with the most advanced realtime speech-to-speech AI.</p>

        </div>

        {(isSafari || isFirefox) && (
            <div className="safari-banner">

              <span>Some features may not work optimally in <b>Safari</b> or <b>Firefox</b>. For the best experience, please use <b>Chrome</b> or <b>Microsoft Edge</b>.</span>
            </div>
          )}
        <div className="linkedin-button-wrapper">

          <LinkedinButton/>
        </div>

        <div className="feature-cards">
          <div className="feature-card">
            <label>Personalized</label>
            <p>Our AI interviewer will ask questions tailored to the job description you give it.</p>
          </div>
          <div className="feature-card">
            <label>Realistic</label>
            <p>Realtime voice-to-voice speech makes the conversation feel natural.</p>
          </div>
          <div className="feature-card">
            <label>Feedback</label>
            <p>Get feedback about what you can do to improve on your next interview.</p>
          </div>

        </div>
      </main>
    </div>
  );
};

function LinkedinButton() {
  const handleClick = () => {
    window.location.href = '/aiproxy/start_linkedin_login_flow';
  };
  return (
    <>
      <button
        type="submit"
        id="linkedin-button"
        onClick={handleClick}
      >
        <LinkedinLogo size={17} weight="fill" color="white" />Continue with LinkedIn
      </button>
    </>
  );
}
